<template>
  <div class="action-button">
    <CButton
      class="btn-outline-info btn btn-action"
      v-c-tooltip.hover.click="'Edit'"
      @click="doEdit(object)"
    >
      <i class="cil-pencil"></i>
    </CButton>
    <CButton
      v-if="!object.deleted_at"
      class="btn-outline-danger btn btn-action"
      v-c-tooltip.hover.click="'Delete'"
      @click="deleteConfirm = true"
    >
      <i class="cil-trash"></i>
    </CButton>
    <CModal
      title="Delete Confirmation"
      size="sm"
      color="danger"
      :show.sync="deleteConfirm"
    >
      Yakin Akan menghapus data
      <strong>"{{ object.name }}"</strong> ?
      <template #footer>
        <CButton @click="deleteConfirm = false" color="danger">Batal</CButton>
        <CButton @click="actionDelete" color="success">Yakin</CButton>
      </template>
    </CModal>
  </div>
</template>
<script>
export default {
  data () {
    return {
      deleteConfirm: false
    };
  },
  props: ["object"],
  methods: {
    doEdit () {
      this.$emit("doEdit", this.object);
    },
    actionDelete () {
      this.deleteConfirm = false;
      this.$emit("actionDelete", this.object);
    }
  }
};
</script>